import { render, staticRenderFns } from "./VeJwBjggModal.vue?vue&type=template&id=ec29fe86"
import script from "./VeJwBjggModal.vue?vue&type=script&lang=js"
export * from "./VeJwBjggModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports